<template>
  <Screen>
    <AppBar :title="title" />
    <Breadcrumbs
      :links="[
        {
          to: $route('admin.ebooks.index'),
          title: 'E-books',
        },
      ]"
      :title="title"
    />
    <div class="row">
      <div class="col-lg-6">
        <div class="card card-body">
          <form action="" method="post" @submit.prevent="submit" v-if="formSet">
            <TextBox
              name="title"
              v-model="form.title"
              :disabled="form.processing"
              :error="form.errors.title"
            />
            <TextBox
              name="author"
              v-model="form.author"
              :disabled="form.processing"
              :error="form.errors.author"
            />
            <TextBox
              name="link"
              type="url"
              v-model="form.link"
              :disabled="form.processing"
              :error="form.errors.link"
            />
            <FileInput
              name="thumbnail"
              v-model="form.thumbnail"
              :fileUrl="form.thumbnail_url"
              :disabled="form.processing"
              :error="form.errors.thumbnail"
              helperText="Ideal size is 1410x2250 pixels. Upload svg file for better quality"
            />
            <StatusRadio
              v-model="form.isactive"
              :disabled="form.processing"
              :error="form.errors.isactive"
            />
            <div class="text-center">
              <button
                class="btn btn-primary w-25"
                type="submit"
                :disabled="form.processing"
                @click.prevent="submit"
              >
                <div
                  class="spinner-border spinner-border-sm"
                  role="status"
                  v-if="form.processing"
                ></div>
                <span v-else>Save</span>
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </Screen>
</template>
<script>
import FileInput from "@/components/form/fileInput.vue";

export default {
  props: {
    title: {
      type: String,
      default: "",
    },
    blissciplines: {
      type: [Object, Array],
      default: () => [],
    },
    formData: {
      type: [Object, Array],
      default: () => {},
    },
    submitUrl: {
      type: String,
      default: "",
    },
    editMode: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    FileInput,
  },
  data() {
    return {
      form: {},
      formSet: false,
      fileName: "Choose file",
    };
  },
  mounted() {
    setTimeout(() => {
      this.form = this.$inertia.form(this.formData);
      this.fileName = this.form.animation || "Choose file";
      this.form.animation = null;
      this.form.thumbnail = null;
      setTimeout(() => {
        this.formSet = true;
      });
    });
  },
  methods: {
    submit() {
      this.form.post(this.submitUrl, {
        onSuccess: () => this.form.reset(),
      });
    },
    fileOnChange(event) {
      let reader = new FileReader();
      reader.readAsDataURL(event.target.files[0]);

      reader.onload = () => {
        this.fileName = event.target.files[0].name;
        this.form.animation = event.target.files[0];
      };
    },
  },
  computed: {},
};
</script>
<style lang="scss" scoped>
.content-type-help {
  padding: 1rem;
  border: 2px solid var(--warning);
  border-radius: var(--border-radius);
  margin-bottom: 1rem;
}
</style>